import APP_CONFIG from 'constants/clientConfigs'
import {
  CLIENT_CODES_CO_UK,
  CLIENT_COUPONS_CA,
  CLIENT_DISCOUNT_CODES,
  CLIENT_PROMO_CODES,
} from 'constants/siteIds'

const PORTAL_SITES = {
  [CLIENT_PROMO_CODES]: {source: 'promocodes', brand: 'Promocodes.com'},
  [CLIENT_DISCOUNT_CODES]: {
    source: 'discountcodesus',
    brand: 'Discountcodes.com',
  },
  [CLIENT_CODES_CO_UK]: {source: 'codesuk', brand: 'Codes.co.uk'},
  [CLIENT_COUPONS_CA]: {source: 'couponsca', brand: 'Coupons.ca'},
}

export default function NewPortalBanner() {
  const clientId = String(process.env.REACT_APP_CLIENT_ID || '')
  const site = PORTAL_SITES[clientId]
  const brand =
    site?.brand || APP_CONFIG[clientId]?.siteName || 'your site'
  const source = site?.source || 'promocodes'
  const href = `https://adcenter.surfmyads.com/login/?source=${encodeURIComponent(
    source,
  )}`

  return (
    <div
      role="region"
      aria-label="New AdCenter portal"
      style={{
        background: '#F5EBD9',
        borderTop: '2px solid #5C3A21',
        color: '#5C3A21',
        fontFamily:
          'ui-sans-serif, system-ui, -apple-system, Segoe UI, sans-serif',
        fontSize: 13,
        lineHeight: 1.4,
        padding: '8px 16px',
        textAlign: 'center',
      }}>
      <p style={{margin: 0}}>
        A new AdCenter portal is available for {brand}.{' '}
        <a
          href={href}
          style={{
            color: '#3F2716',
            fontWeight: 600,
            textDecoration: 'underline',
          }}>
          Open the new portal
        </a>
      </p>
    </div>
  )
}
